"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LeHookPuissant() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const text = "VOTRE PROPRIÉTÉ, NOTRE EXPERTISE";
  const words = text.split(" ");
  return <section data-section-id="115764" id="votre-propriété-notre-expertise" className="bg-background text-foreground min-h-[80vh] flex flex-col items-center justify-center px-4 py-24 overflow-hidden selection:bg-accent selection:text-accent-foreground">
      <div ref={ref} className="w-full max-w-[95vw] md:max-w-[85vw] mx-auto flex items-center justify-center">
        <h2 className="text-[13vw] sm:text-[11vw] md:text-[9vw] lg:text-[7.5vw] xl:text-[6.5vw] font-default font-bold tracking-tighter leading-[0.85] uppercase text-center flex flex-wrap justify-center items-center text-primary">
          {words.map((word, i) => <span key={i} data-index={i} className={`inline-block mr-[0.25em] mb-[0.1em] transition-all duration-1000 ease-out will-change-transform ${isVisible ? "opacity-100 translate-y-0 blur-none" : "opacity-0 translate-y-16 blur-sm"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {word}
            </span>)}
        </h2>
      </div>
    </section>;
}